export const menuItemsData = [
  {
    id: 0,
    title: "Chaofan",
    list: [
      {
        name: "Chicken Chaofan",
        desc: "Wok-fried rice with chicken, fresh veggies, and our signature Origin seasoning.",
        price: "ETB 350",
      },
      {
        name: "Beef Chaofan",
        desc: "Flavorful beef fried rice with vegetables and house sauce.",
        price: "ETB 390",
      },
      {
        name: "Mixed Chaofan (Chicken + Beef)",
        desc: "Best of both worlds: chicken and beef with wok-char flavor.",
        price: "ETB 450",
      },
      {
        name: "Veggie Chaofan",
        desc: "Crisp vegetables, garlic, and soy-style seasoning (no meat).",
        price: "ETB 300",
      },
      {
        name: "Spicy Chaofan",
        desc: "Our signature chaofan with extra heat and bold flavor.",
        price: "ETB 370",
      },
      {
        name: "Origin Special Chaofan",
        desc: "Chef’s special fried rice with premium mix-ins and extra seasoning.",
        price: "ETB 520",
      },
      {
        name: "Chaofan Combo",
        desc: "Choose any chaofan + fries + soft drink.",
        price: "ETB 620",
      },
    ],
  },

  {
    id: 1,
    title: "Steak Sandwiches",
    list: [
      {
        name: "Classic Steak Sandwich",
        desc: "Juicy steak slices, caramelized onions, fresh salad, and house sauce.",
        price: "ETB 480",
      },
      {
        name: "Spicy Steak Sandwich",
        desc: "Classic steak sandwich with our spicy sauce and extra kick.",
        price: "ETB 520",
      },
      {
        name: "Cheesy Steak Sandwich",
        desc: "Juicy steak with melted cheese and toasted bread.",
        price: "ETB 560",
      },
      {
        name: "Steak Sandwich + Fries",
        desc: "Your favorite steak sandwich served with crispy fries.",
        price: "ETB 650",
      },
      {
        name: "Steak Sandwich Combo",
        desc: "Steak sandwich + fries + soft drink.",
        price: "ETB 760",
      },
    ],
  },
  {
    id: 2,
    title: "Hotdogs",
    list: [
      {
        name: "Classic Hotdog",
        desc: "Classic hotdog with ketchup, mustard, and crunchy toppings.",
        price: "ETB 220",
      },
      {
        name: "Cheesy Hotdog",
        desc: "Classic hotdog topped with melted cheese.",
        price: "ETB 260",
      },
      {
        name: "Spicy Hotdog",
        desc: "Hotdog with spicy sauce and jalapeño-style heat.",
        price: "ETB 260",
      },
      {
        name: "Hotdog + Fries",
        desc: "Classic hotdog served with crispy fries.",
        price: "ETB 390",
      },
      {
        name: "Hotdog Combo",
        desc: "Hotdog + fries + soft drink.",
        price: "ETB 520",
      },
    ],
  },
  {
    id: 3,
    title: "Fries",
    list: [
      {
        name: "Classic Fries",
        desc: "Golden crispy fries, lightly salted.",
        price: "ETB 180",
      },
      {
        name: "Spicy Fries",
        desc: "Classic fries with spicy seasoning.",
        price: "ETB 200",
      },
      {
        name: "Cheesy Fries",
        desc: "Crispy fries topped with melted cheese.",
        price: "ETB 260",
      },
      {
        name: "Loaded Fries",
        desc: "Fries loaded with sauce, cheese, and crunchy toppings.",
        price: "ETB 320",
      },
    ],
  },
  {
    id: 4,
    title: "Ice-Cold Drinks",
    list: [
      {
        name: "Soft Drink",
        desc: "Served ice-cold.",
        price: "ETB 80",
      },
      {
        name: "Bottled Water",
        desc: "Chilled water.",
        price: "ETB 50",
      },
      {
        name: "Iced Tea",
        desc: "Refreshing iced tea served cold.",
        price: "ETB 100",
      },
      {
        name: "Fresh Juice",
        desc: "Seasonal fresh juice.",
        price: "ETB 140",
      },
    ],
  },
]
